import styled from 'styled-components'
import {FlexView} from "./index";

const FlexViewTable = styled(FlexView)`
  overflow: hidden;
  background: #000;
  min-width: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: flex-start;
  background-color: #e5e5e5;
`

export default FlexViewTable
